/** Chime curto/moderno para mensagem nova no Board Chat (Web Audio, sem asset). */

const COOLDOWN_MS = 1800;

let audioCtx = null;
let lastPlayAt = 0;
let unlockBound = false;

function getAudioContext() {
  if (typeof window === 'undefined') return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!audioCtx) audioCtx = new AC();
  return audioCtx;
}

/** Registra um gesto do usuário para liberar o AudioContext (autoplay). */
export function armBoardChatNotifySound() {
  if (unlockBound || typeof document === 'undefined') return;
  unlockBound = true;
  const unlock = () => {
    const ctx = getAudioContext();
    if (ctx?.state === 'suspended') {
      ctx.resume().catch(() => {});
    }
  };
  document.addEventListener('pointerdown', unlock, { once: true, passive: true });
  document.addEventListener('keydown', unlock, { once: true });
}

function playTone(ctx, start, freq, duration, peakGain) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.setValueAtTime(freq, start);
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(peakGain, start + 0.018);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(start);
  osc.stop(start + duration + 0.03);
}

/**
 * Toca um bip suave (dois tons). Ignora se ainda no cooldown.
 */
export function playBoardChatNewMessageSound() {
  armBoardChatNotifySound();
  const now = Date.now();
  if (now - lastPlayAt < COOLDOWN_MS) return;
  lastPlayAt = now;

  try {
    const ctx = getAudioContext();
    if (!ctx) return;
    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }
    const t0 = ctx.currentTime + 0.01;
    playTone(ctx, t0, 880, 0.11, 0.04);
    playTone(ctx, t0 + 0.09, 1174.66, 0.14, 0.032);
  } catch {
    /* silencioso */
  }
}
